import React, { useState, useEffect } from 'react';
import { graphql, navigate } from 'gatsby';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import ToolboxLayout from 'layouts/toolboxLayout';
import Hero from 'components/Tools/Hero';
import { BCHomeForm } from 'components/Tools/BusinessCalculator/HomeForm';
import DescriptionBlock from 'components/Tools/DescriptionBlock';
import { createToolsBreadcrumbs } from '../utils/createToolsBreadcrumbs';

const BusinessCalcPage = props => {
  const data = props.data.contentfulTool;
  const breadcrumbs = createToolsBreadcrumbs('Business Valuation Calculator');

  const [values, setValues] = useState({
    industry: '',
    otherIndustry: '',
    state: '',
  });

  const convertParams = formValues => {
    return (
      'industry=' +
      formValues['industry'] +
      '&otherIndustry=' +
      formValues['otherIndustry'] +
      '&state=' +
      formValues['state']
    );
  };

  const onClickNext = formValues => {
    navigate(`/${data.seo.pageUrl}/revenue?` + convertParams(formValues));
  };

  useEffect(() => {
    const url = props.location.search;
    const params = queryString.parse(url);
    const tempValues = { ...values };
    Object.keys(tempValues).map(key => {
      if (params[key]) {
        tempValues[key] = params[key];
        Cookies.set(key, params[key]);
      }
    });
    setValues(tempValues);
  }, []);

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={data.seo} {...props}>
      <Hero data={data.hero} />
      <BCHomeForm onClickNext={onClickNext} formValues={values} />
      {data.description && <DescriptionBlock data={data.description} />}
    </ToolboxLayout>
  );
};

export default BusinessCalcPage;

export const BusinessCalcPageQuery = graphql`
  query BusinessCalcPageQuery {
    contentfulTool(internalName: { eq: "Business Valuation Calculator" }) {
      ...Tool
    }
  }
`;
